<template>
	<!-- Returns objects, multiple selection is possible, displays chips -->
	<!-- EXAMPLE USE
		<autocomplete
			:items="formItems.mandator"
			label="Mandator"
			:model.sync="formState.selectedMandators"
		>
		</autocomplete>
	-->
	<div>
		<v-autocomplete
			v-show="show"
			v-model="modelLocal"
			:items="items"
			:error-count="errorCount"
			:error-messages="errorMessage"
			:search-input.sync="searchLocal"
			hide-selected
			:label="label"
			:multiple="!solo"
			:solo="solo"
			persistent-hint
			chips
			return-object
			@change="selectedValueEmit"
		/>
	</div>
</template>

<script>
export default {
	name: 'AutocompleteBasic',
	props: {
		show: {
			type: Boolean,
			default: true,
		},
		model: {
			type: Array,
			required: true,
		},
		items: {
			tpye: Array,
			required: true,
			default: ['could not be loaded'],
		},
		label: {
			type: String,
			required: true,
		},
		errorCount: {
			type: Number,
			default: 0,
		},
		errorMessage: {
			type: String,
			default: '',
		},
		search: {
			default: null,
		},
		solo: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			modelLocal: this.model,
			searchLocal: this.search,
		}
	},
	methods: {
		selectedValueEmit() {
			this.$emit('update:model', this.modelLocal)
			this.$emit('update:search', this.searchLocal)
		},
	},
}
</script>

<style>

</style>
